import { StyleEntry } from 'Shared/backend/styleUtils';
import { buttonStyleTag, subNavButtonStyleTag } from 'Shared/model/venueSettings';
import { VenueStyleUi } from 'Shared/themes/VenueStyleUi';


/*
	The 'Buttons' style category - which of the venue's own styles the buttons the code draws itself
	are dressed in.

	Neither entry has rules: there is nothing here for the resolver to lay on a component, because a
	button's css is built in code and the components that draw one never go near the style path. What
	the tag carries is a name, in params.style, and buttonStyleCss.ts reads it back off the style chain
	at the button. 'Parent styles to cancel' and 'Classes' in toolStyles.ts are ruleless the same way.

	That still gives the scoping the rest of the catalogue has, and for the same reason: the tag rides
	the chain, so the site-wide list, a page's own styles and a Styles widget's each add one further in
	than the last, and the innermost wins.
*/
export function buttonStyles(): {[name: string]: StyleEntry}
{
	return {
		[buttonStyleTag]: {
			explanation: 'Dress every button below this in one of your venue styles. On a page or in a Styles widget this replaces the site-wide button style outright.',
			ui: VenueStyleUi,
			initial: {style: ''},
			rules: [],
		},

		[subNavButtonStyleTag]: {
			explanation: "Dress the rows of buttons under a page heading - an event's lineup filters, a menu's section jumps, a widget's sticky button row. On a page or in a Styles widget this replaces the site-wide sub nav button style outright.",
			ui: VenueStyleUi,
			initial: {style: ''},
			rules: [],
		},
	};
}
